module.exports = __webpack_public_path__ + "img/circle.23471b4c.svg";